/* eslint-disable react/no-danger */
import styles from './AnnotatedImageWrapper.scss';
import AnnotatedImage from 'edrolo/domains/exams/components/AnnotatedImage';

const AnnotatedImageWrapper = (props) => {
  return (
    <div>
      <h3 className={styles.annotatedImageHeading}>Exemplar Response</h3>
      <AnnotatedImage readOnly {...props} />
    </div>
  );
};

export default AnnotatedImageWrapper;
